var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{attrs:{"shadow":"never","body-style":{ padding: '10px' }}},[_c('Main',{ref:"tableMain",attrs:{"loading":_vm.loading,"tableData":_vm.tableData},on:{"reload":function () { return this$1.$emit('refresh'); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }